import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'material-ui/Tabs';
import { tabStyles } from '../../../theme/AllocateBaseTheme';
import SettingsNSync from '../../../components/Admin/SystemInfo/SettingsNSync';
import SyncLog from '../../../components/Admin/SystemInfo/SyncLog';
import globals from '../../../globals/communityGlobals';
import DefaultPageWraper from '../../../containers/PageStructure/DefaultPageWrapper/DefaultPageWrapperContainer';

const locale = globals.getArea('admin');

class SystemInfo extends React.Component {
  setTableRef = table => {
    this.table = table;
  };
  render() {
    const { pageTitle, sysInfo, ...rest } = this.props;

    return (
      <DefaultPageWraper pageTitle={pageTitle}>
        <Tabs tabItemContainerStyle={tabStyles.tabItemContainerStyle} inkBarStyle={tabStyles.inkBarStyle}>
          <Tab buttonStyle={tabStyles.buttonStyle} label={locale.getMsg('systemInfo')}>
            <SettingsNSync sysInfo={sysInfo} table={this.table} {...rest} />
          </Tab>
          <Tab buttonStyle={tabStyles.buttonStyle} label={locale.getMsg('synchronizationLog')}>
            <SyncLog setTableRef={this.setTableRef} />
          </Tab>
        </Tabs>
      </DefaultPageWraper>
    );
  }
}

SystemInfo.defaultProps = {
  sysInfo: null,
};

SystemInfo.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  sysInfo: PropTypes.objectOf(PropTypes.string),
};

export default SystemInfo;
